import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getRentalAssets} from "../../../api/lifecycle/rental/rentalAssetService";
import RentalAssetListType from "./rentalAssetListType";
import RentalAssetThumbType from "./rentalAssetThumbType";

const RentalAsset = () => {
    const [listType, setListType] = useState(true);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const {data, newData, pageInfo, dataHook} = useRequestData(getRentalAssets, initDate, "rental_asset");

    return (
        <div className={"common-container"}>
            <PageHeader header={"대여자산관리"}/>
            {listType ?
                <RentalAssetListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
                :
                <RentalAssetThumbType
                    data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                />
            }
        </div>
    );
};

export default RentalAsset;